import React from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { PAYMENT_ROUTES } from "../../routePaths";
import "../PaymentSuccess/PaymentStatus.css";

export default function PaymentFail() {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const backRoute =
    searchParams.get("userType") === "doctor" ? "/subscription" : PAYMENT_ROUTES.PLANS;

  return (
    <div
      className="payment-status-page"
      dir={i18n.dir(i18n.resolvedLanguage || i18n.language)}
    >
      <div className="payment-status-card payment-status-card--fail">
        <div className="payment-status-icon" aria-hidden="true">✕</div>
        <h1>{t("payment.result.fail.title")}</h1>
        <p>{t("payment.result.fail.message")}</p>
        <button type="button" onClick={() => navigate(backRoute)}>
          {t("payment.result.backToSubscription")}
        </button>
      </div>
    </div>
  );
}